export enum MeritSupportSortingParameter {
  Default = 'Default',
  OrgCode = 'OrgCode',
  MercerJobFamily = 'MercerJobFamily',
  MercerJobSubFamily = 'MercerJobSubFamily',
  PositionClass = 'PositionClass'
}
